import React, { useEffect, useState } from "react";
import {
  Paper,
  Button,
  Box,
  Typography,
  Avatar,
  Skeleton,
} from "@mui/material";
// import freeVoteIcon from "../../../assets/customerAssets/icons/voteIcon.svg";
// import freeVoteIconV from "../../../assets/customerAssets/freeVotesIcon.svg";
import freeVoteIcon from "../../../assets/customerAssets/icons/crownVoteIcon.svg";
import freeVoteIconV from "../../../assets/customerAssets/icons/crownVoteIconRed.svg";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addVote , addGuestVote} from "../../../api/addVote";
import { getGoalVotes } from "../../../api/getGoalVote";
import { Navigate, useNavigate } from "react-router-dom";
import { addVote as addClubVotes } from "../../../api/addClubVote";
import GuestUserRistModal from "../../Modals/user/guestUserModalRist/Modal";
import { handleGuestVoteFailure } from "../../../utils/guestVote";

const VoteComponent = ({ vote, id, count, isClub, allow }) => {
  const [clicked, setClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [gcount, setCount] = useState(count);
  const [countLoading, setCountLoading] = useState(false);
  const [guestModal, setGuestModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const loggedUser = useSelector((state) => state.loggedUser.user);
  const token = useSelector((state) => state.auth.token);
  const handleClicked = async () => {
    if (isClub && !allow) {
      toast.error("Private Club!, Only club members can vote for the club.");
      return;
    }
    try {
      // "";
      // if (user.data.is_skip) {
      //   navigate("/register");
      //   return;
      // }

      setCountLoading(true);
      setLoading(true);
      if (loggedUser.device_id) {
        console.log("initiate vote api for guest")
        console.log(loggedUser,"logged user in vote component")
        const data = await addGuestVote(loggedUser.id,id, token);

        if (data.success) {
          setCount((gcount) => gcount + 1);
          setCountLoading(false);
          // dispatch({ type: "DCREMENT_VOTE" });

          setLoading(false);
          setClicked(true);
          toast.success(data.message);
        } else {
          handleGuestVoteFailure(data, {
            onLimit: () => setGuestModal(true),
            onDisabled: (msg) => toast.error(msg || data.message),
          });
          if (!data?.success) toast.error(data.message);
        }
        // navigate("/register");
        return;
      }

      if (token && user.data.id) {
        let data;
        if (isClub) {
          data = await addClubVotes(user.data.id, id, token);
        } else {
          data = await addVote(user.data.id, id, token);
        }
        if (data.success) {
          setCount((gcount) => gcount + 1);
          setCountLoading(false);
          dispatch({ type: "DCREMENT_VOTE" });

          setLoading(false);
          setClicked(true);
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
      } else {
      }
    } catch (error) {
      if (error.guestVotingDisabled) {
        toast.error(error.message);
      } else if (error.requiresRegistration) {
        setGuestModal(true);
      }
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <GuestUserRistModal open={guestModal} setOpen={setGuestModal} />
      {loading ? (
        <Button className="icon-di" onClick={() => {}}>
          <Skeleton animation="wave" height={27} width={27} />
        </Button>
      ) : (
        <Button className="icon-div" onClick={handleClicked}>
          <img
            src={vote || clicked ? freeVoteIconV : freeVoteIcon}
            className="iconImg"
          />
        </Button>
      )}
      {loading ? (
        <Skeleton
          animation="wave"
          // height={27}
          // width={27}
          variant="p"
        />
      ) : (
        <Typography component="p">{gcount}</Typography>
      )}
    </>
  );
};

export default VoteComponent;
